module.exports = __webpack_public_path__ + "static/img/sustainable-solutions-rnd-microsoft.e2f50df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/sustainable-solutions-rnd-microsoft.png
// module id = J6KV
// module chunks = 0